/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';

export const LOGIN_USER_IMAGE_SUCCESS = 'LOGIN_USER_IMAGE_SUCCESS';
export const LOGIN_USER_IMAGE_ERROR = 'LOGIN_USER_IMAGE_ERROR';
